import React from 'react'

const Terbaru = () => {
  return (
    <div>Terbaru</div>
  )
}

export default Terbaru